import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './PersonalDetailsPage.css';

function PersonalDetailsPage({ data, updateData }) {
  const [formData, setFormData] = useState(data.personalDetails || {
    fullName: '',
    dob: '',
    gender: '',
    employmentStatus: '',
    educationLevel: '',
    hasOutstandingLoan: '',
    referralSource: ''
  });
  
  const navigate = useNavigate();

  const employmentOptions = ['Have a job', 'Self Employed', 'Student', 'No income'];
  const educationOptions = ['None', 'Primary', 'Secondary', 'College/University'];
  const referralOptions = ['Social Media', 'Searching Online', 'Friend/Family', 'Government Office', 'Other'];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleContinue = () => {
    // Validate all fields
    const requiredFields = ['fullName', 'dob', 'gender', 'employmentStatus', 'educationLevel', 'hasOutstandingLoan', 'referralSource'];
    const missingFields = requiredFields.filter(field => !formData[field]);
    
    if (missingFields.length > 0) {
      alert('Please fill in all required fields');
      return;
    }
    
    updateData('personalDetails', formData);
    navigate('/financial-details');
  };

  return (
    <div className="personal-details-page">
      <div className="container">
        <div className="page-header">
          <h2>Personal Details</h2>
          <p>Please provide your personal information</p>
        </div>

        <form className="personal-form">
          <div className="form-group">
            <label>Full Name *</label>
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              placeholder="Enter your full name"
              required
            />
          </div>

          <div className="form-group">
            <label>Date of Birth *</label>
            <input
              type="date"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Gender *</label>
            <div className="radio-group">
              {['Male', 'Female', 'Other'].map(gender => (
                <label key={gender} className="radio-label">
                  <input
                    type="radio"
                    name="gender"
                    value={gender.toLowerCase()}
                    checked={formData.gender === gender.toLowerCase()}
                    onChange={handleChange}
                  />
                  {gender}
                </label>
              ))}
            </div>
          </div>

          <div className="form-group">
            <label>Employment Status *</label>
            <div className="options-grid">
              {employmentOptions.map(option => (
                <button
                  key={option}
                  type="button"
                  className={`option-btn ${formData.employmentStatus === option ? 'selected' : ''}`}
                  onClick={() => handleChange({ target: { name: 'employmentStatus', value: option } })}
                >
                  {option}
                </button>
              ))}
            </div>
          </div>

          <div className="form-group">
            <label>Education Level *</label>
            <select
              name="educationLevel"
              value={formData.educationLevel}
              onChange={handleChange}
              required
            >
              <option value="">Select education level</option>
              {educationOptions.map(option => (
                <option key={option} value={option.toLowerCase()}>{option}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Do you have any outstanding loan? *</label>
            <div className="radio-group">
              {['Yes', 'No'].map(option => (
                <label key={option} className="radio-label">
                  <input
                    type="radio"
                    name="hasOutstandingLoan"
                    value={option.toLowerCase()}
                    checked={formData.hasOutstandingLoan === option.toLowerCase()}
                    onChange={handleChange}
                  />
                  {option}
                </label>
              ))}
            </div>
          </div>

          <div className="form-group">
            <label>Where did you hear about us? *</label>
            <select
              name="referralSource"
              value={formData.referralSource}
              onChange={handleChange}
              required
            >
              <option value="">Select option</option>
              {referralOptions.map(option => (
                <option key={option} value={option.toLowerCase()}>{option}</option>
              ))}
            </select>
          </div>

          <button 
            type="button"
            className="continue-btn"
            onClick={handleContinue}
          >
            Continue
          </button>
        </form>
      </div>
    </div>
  );
}

export default PersonalDetailsPage;